module.exports = __webpack_public_path__ + "img/bm.6e0040cb.png";